import { Routes } from '@angular/router';
import { RouteEntity } from '@core/router/route.entity';
import { CookieMessageComponent } from '@ui/layout/cookie-message/cookie-message.component';
import { HeaderComponent } from '@ui/layout/header/header.component';
import { FooterComponent } from '@ui/layout/footer/footer.component';
import { AuthWithTempPasswordGuard } from '@core/auth/guards/auth-with-temp-password.guard';
import { RoutingQueryParamsName } from '@core/router/routing.params';


export const commonModuleRoutes: Routes = [
    {
        path: RouteEntity.Empty,
        component: CookieMessageComponent,
        outlet: 'cookie-message',
    },
    {
        path: RouteEntity.Empty,
        component: HeaderComponent,
        outlet: 'header',
    },
    {
        path: RouteEntity.Empty,
        component: FooterComponent,
        outlet: 'footer',
    },
    {
        path: RouteEntity.Logout,
        loadComponent: () =>
            import('@ui/features/logout/logout.component').then(
                (c) => c.LogoutComponent,
            ),
        canLoad: [AuthWithTempPasswordGuard],
    },
    {
        path: RouteEntity.Login,
        loadComponent: () =>
            import('@ui/features/login/login.component').then(
                (c) => c.LoginComponent,
            ),
    },
    {
        path: RouteEntity.UserSettings,
        loadComponent: () =>
            import('@ui/features/page-settings/page-settings.component').then(
                (c) => c.PageSettingsComponent,
            ),
        canLoad: [AuthWithTempPasswordGuard],
    },
    {
        path: RouteEntity.Error + '/:' + RoutingQueryParamsName.Code,
        loadComponent: () =>
            import('@ui/features/error-container/error-container.component').then(
                (c) => c.ErrorContainerComponent,
            ),
    },
    {
        path: RouteEntity.CookiePolicy,
        loadComponent: () =>
            import('@ui/layout/cookie-policy-text/cookie-policy-text.component').then(
                (c) => c.CookiePolicyTextComponent,
            ),
    },
];

export const commonErrorRoutes: Routes = [
    {
        path: '**',
        redirectTo: RouteEntity.Error + '/' + RouteEntity.Error404,
    },
];
